export default "__VITE_ASSET__BennVVmU__"